import { render, staticRenderFns } from "./SalesDashboardNumber.vue?vue&type=template&id=1b8b8742&"
import script from "./SalesDashboardNumber.vue?vue&type=script&lang=js&"
export * from "./SalesDashboardNumber.vue?vue&type=script&lang=js&"
import style0 from "./SalesDashboardNumber.vue?vue&type=style&index=0&id=1b8b8742&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports